import * as React from "react";
import {useLocalization} from "../../i18n";
import {
    classNames,
    layout,
    PushButton,
    typography,
    View,
    ViewContent, ViewFooter, ViewFooterItem,
    ViewHeader,
    ViewHeaderItem
} from "@variocube/cube-ui";

interface ReUseContainerViewProps {
    onNext: (takeContainer: boolean) => void;
    onCancel: () => void;
}

export function ReUseContainerView(props: ReUseContainerViewProps) {
    const {onNext, onCancel} = props;
    const {t} = useLocalization();

    return (
        <View>
            <ViewHeader>
                <ViewHeaderItem className={layout.paddingMedium}>
                    <div className={typography.title}>
                        {t("ReUseContainerTitle")}
                    </div>
                    <div className={typography.description}>
                        {t("ReUseContainerDescription")}
                    </div>
                </ViewHeaderItem>
            </ViewHeader>
            <ViewContent className={layout.paddingMedium}>
                <div className={classNames(layout.vertical, layout.spaceBetween)}>
                    <div className={classNames(typography.bigger, layout.paddingLarge)}>
                        {t("ReUseInfo1")}
                    </div>
                    <div className={classNames(typography.bigger, layout.paddingLarge)}>
                        {t("ReUseInfo2")}
                    </div>
                    <div className={classNames(typography.title, typography.alignCenter, layout.paddingLarge)}>
                        {t("ReUseQuestion")}
                    </div>
                </div>
            </ViewContent>
            <ViewFooter className={classNames(layout.spaceBetween, layout.paddingMedium)}>
                <ViewFooterItem>
                    <PushButton onClick={() => onCancel()}>
                        {t("Cancel")}
                    </PushButton>
                </ViewFooterItem>
                <ViewFooterItem>
                    <PushButton onClick={() => onNext(true)}>
                        {t("ReuseTakeWithYou")}
                    </PushButton>
                </ViewFooterItem>
                <ViewFooterItem>
                    <PushButton primary onClick={() => onNext(false)}>
                        {t("ReUseLeaveInLocker")}
                    </PushButton>
                </ViewFooterItem>
            </ViewFooter>
        </View>
    );
}
